import React, { useRef } from 'react'
import './../App.css';

function Star({ data, index, status, onClick }) {
  const el = useRef();

  return <div
    className={`orbiting-star orbiting-star-${status} orbiting-star-${status}-${index}`}
    ref={el}
    onClick={onClick ?? null}
  >
    {data.kind === "constellation" &&
      <div className="constellation">
        <div className="shiny-object-group">
          <div className="shiny-object"></div>
          <div className="shiny-object"></div>
          <div className="shiny-object"></div>
        </div>
        <span className="name">{data.name}</span>
      </div>
    }
    {data.kind === "person" &&
      <div className="person">
        <div className="shiny-object"></div>
        <span className="name">{data.name}</span>
      </div>
    }
  </div>;
}

export default Star;